import { useTranslation } from "react-i18next";
import { formatDate, getRelativeTime } from "../../utils/formatDate";

function FormattedDate({ date, short, long, noTooltip, className }) {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  if (!date) return <span className={className}>—</span>;

  const formatted = formatDate(date, locale, { short, long });
  const relative = noTooltip ? null : getRelativeTime(date, locale);

  return (
    <span className={className} title={relative || undefined}>
      {formatted}
    </span>
  );
}

export default FormattedDate;
